var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveyLifestyle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 9.99951C25.0002 6.68581 27.6865 3.99951 31.0002 3.99951H85.0002C87.2094 3.99951 89.0002 5.79037 89.0002 7.99951V83.9995C89.0002 86.2087 87.2094 87.9995 85.0002 87.9995H31.0002C27.6865 87.9995 25.0002 85.3132 25.0002 81.9995V9.99951Z",
    fill: "#E4E1FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0002 63H25.0002V88H91.0002V63Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 3.99951L80 3.99951L80 22.9995L76 20.4086L72 22.9995L72 3.99951Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3258 46.0688L92.8203 93.9947L65.4744 93.9947L59.969 46.0688L98.3258 46.0688Z",
    fill: "#8372FF",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50L57 50L57.3488 47.3287C57.498 46.1876 58.2212 45.3563 59.0656 45.3563L59.8203 45.3563L60.3741 42.4568C60.7624 40.4202 62.103 39 63.6366 39L94.3634 39C95.897 39 97.237 40.4202 97.6259 42.4568L98.1791 45.3563L98.9344 45.3563C99.7788 45.3563 100.502 46.1876 100.651 47.3287L101 50Z",
    fill: "#1B1B1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5002 74C83.1947 74 87.0002 70.1944 87.0002 65.5C87.0002 60.8056 83.1947 57 78.5002 57C73.8058 57 70.0002 60.8056 70.0002 65.5C70.0002 70.1944 73.8058 74 78.5002 74Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1054 86.2368C53.2956 80.7014 45.5587 58.8287 33.038 48.2385",
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6381 41.6127C16.1917 41.5351 12.8478 42.601 12.5762 44.4006C12.2404 46.6942 20.8897 49.942 23.2847 50.2509C26.1856 50.6251 32.7922 51.2545 34.8706 48.6096C35.8634 47.5967 36.2575 45.2199 36.0092 42.2346L36.003 42.2336C35.8423 40.4338 35.5089 38.6536 35.0076 36.9175C33.279 30.8328 30.0697 26.4115 27.839 27.0465C26.0907 27.5424 25.4481 30.9999 26.1047 35.3962C21.8266 32.1035 17.6313 30.6878 16.2578 32.2457C14.8842 33.8037 16.8221 37.7962 20.6381 41.6127Z",
    fill: "#FFBB00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3844 74.278C44.6718 75.624 50.0487 75.4076 50.394 73.7947C50.7393 72.1818 45.9222 69.7831 39.6348 68.4371C33.3474 67.0911 27.9706 67.3075 27.6253 68.9204C27.28 70.5333 32.097 72.932 38.3844 74.278Z",
    fill: "#1B1B1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8531 52.1762C46.4019 56.9121 44.0558 60.3928 42.6129 59.9507C41.1699 59.5085 41.1766 55.3109 42.6278 50.575C44.079 45.8392 46.4251 42.3584 47.868 42.8006C49.311 43.2427 49.3043 47.4403 47.8531 52.1762Z",
    fill: "#1B1B1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyLifestyle);
export default __webpack_public_path__ + "static/media/survey-lifestyle.9b903ca0.svg";
export { ForwardRef as ReactComponent };